export default "__VITE_ASSET__6i$pEbAb__"